import { render, staticRenderFns } from "./BracketsView.vue?vue&type=template&id=5d3ca9fc&"
import script from "./BracketsView.vue?vue&type=script&lang=js&"
export * from "./BracketsView.vue?vue&type=script&lang=js&"
import style0 from "./BracketsView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports